export default __webpack_public_path__ + "static/media/wallet-scanner.de2d7bc1.svg";